// config.js
const environments = {
    1: "http://localhost:3001",
    2: "https://vicabackend-dot-ind-iusm-chiis-sw-dev.uc.r.appspot.com",
    3: "https://vicabackend-dev-dot-ind-iusm-chiis-sw-dev.uc.r.appspot.com",
  };
  
  const selectedEnv = 3;
  
  const config = {
    API_BASE_URL: environments[selectedEnv],
  };
  
  export default config;
